module.exports = __webpack_public_path__ + "static/media/stop.59f1572e.svg";